<!--
 * @Description: 低代码管理后台登录页面
 * 代码管理后台登录页面代码管理后台登录页面代码管理后台登录页面代码管理后台登录页面代码管理后台登录页面
-->
<template>
	<div class="login">
		<div class="login-content">
			<div class="login-content-left">
				<!-- tabs -->
				<ul class="flex col-bottom mb60">
					<li v-for="tab in tabs" :key="tab.value" class="tab mr20"
						:class="[active == tab.value ? 'tab-active' : '']" @click="active = tab.value">
						{{ tab.label }}
					</li>
				</ul>

				<!-- 代码管理后台登录页面   登录 -->
				<template v-if="active == 'login'">
					<el-form :model="loginForm" ref="login" label-width="0">
						<el-form-item prop="account" class="mb40"
							:verify="{ minLen: 8, maxLen: 16, typeOptions: ['字母|数字'] }">
							<el-input v-model="loginForm.account" placeholder="请输入账户名"></el-input>
						</el-form-item>
						<el-form-item prop="password" class="mb70" :verify="{ passwordOptions: [6, 18, '字母|数字'] }">
							<el-input v-model="loginForm.password" placeholder="输入密码登录" show-password></el-input>
						</el-form-item>
					</el-form>

					<el-button class="w-100 h48 f-white bg-theme r3 f18 lb-4" type="primary"
						@click="login">登录</el-button>
					<div class="flex row-right mt25 f15 f-theme pointer" @click="active = 'register'">
						注册
					</div>
				</template>

				<!-- 代码管理后台登录页面 注册 -->
				<template v-if="active == 'register'">
					<el-form :model="registerForm" ref="register" label-width="0">
						<el-form-item prop="account" class="mb40"
							:verify="{ minLen: 8, maxLen: 16, typeOptions: ['字母|数字'] }">
							<el-input v-model="registerForm.account" placeholder="请输入注册账户"></el-input>
						</el-form-item>
						<el-form-item prop="password" class="mb40" :verify="{ passwordOptions: [6, 18, '字母|数字'] }">
							<el-input v-model="registerForm.password" placeholder="请输入注册密码" show-password></el-input>
						</el-form-item>
						<el-form-item prop="userName" class="mb70" :verify="{ maxLen: 10 }">
							<el-input v-model="registerForm.userName" placeholder="请输入用户名"></el-input>
						</el-form-item>
					</el-form>

					<el-button class="w-100 h48 f-white bg-theme r3 f18 lb-4" type="primary"
						@click="register">注册</el-button>
				</template>
			</div>
			<div class="login-content-right">
				<img class="w-100" src='../assets/image/logo.jpeg' />
			</div>
		</div>
	</div>
</template>

<!-- 代码管理后台登录页面  代码管理后台登录页面 -->
<script>
	import axios from 'axios';
	import {
		mapMutations
	} from "vuex";
	import {
		login,
		register,
		sendWxMsgGet
	} from "@/api/user";

	export default {
		name: "login",

		created() {
			this.logout();
		},

		data() {
			return {
				active: "login",
				loginForm: {
					account: '',
					password: ''
				},
				registerForm: {
					account: '',
					password: '',
					userName: ''
				},
				tabs: [{
						label: "密码登录",
						value: "login"
					},
					{
						label: "免费注册",
						value: "register"
					},
				],
			};
		},

		watch: {
			active: {
				handler(newVal) {
					switch (newVal) {
						case 'login':
							this.loginForm = {
								account: '',
								password: ''
							};
							break;
						case 'register':
							this.registerForm = {
								account: '',
								password: '',
								userName: ''
							};
							break;
						default:
							break;
					}
				},
			},
		},

		methods: {
			...mapMutations(["setToken", "setUserInfo", "logout"]),

			// 登录
			async login() {
				this.$refs["login"].validate(async (valid) => {
					if (valid) {
						let res = await login(this.loginForm);


						//console.log('登录接口返回-->',res);
						if (res.status == "10000") {
							this.$notify({
								title: "登录成功",
								message: "请开始构建您的网页吧！",
								type: "success",
							});
							this.setToken(res.token);
							this.setUserInfo(res.userInfo);
							this.$router.push({
								name: "managet"
							});


							//this.getIP(res);

							let ip = res.ip; //获取ip
							let address = this.getUserAddressByIP(ip);
							//*****推送消息给于世友,确保知道有人随时登录
							let keyword = "商户:" + res.userInfo.userName + ",低代码后台登录, 低代码平台, IP:" + ip +
								address +
								",账号:" + res
								.userInfo.account;
							//let resmsg = await sendWxMsgGet("oINr8jmIimQkTbbdht_KYJsx7HFU", keyword, "");
							let url =
								"https://xcx11.5izg.bj.cn/tools/post.ashx?act=wx_template_notice&openid=oINr8jmIimQkTbbdht_KYJsx7HFU&notice_name=会员充值提醒&first_line=&end_line=&keyword=" +
								keyword +
								"&s_manager=13366682206&kh=13366682206&order_no=&openUrl=&type=超管&name=超管";
							axios.get(url)
								.then(response => {

								})
								.catch(error => {
									console.error("There was an error!", error);
								});

			


						} else {
							this.$notify({
								title: "登录失败",
								message: res.message,
								type: "warning",
							});
						}
					}
				});
			},
			// async getIP(res) {
			// 	let currentIP = "";
			// 	let ipLocation = "";
			// 	try {
			// 		// 纯真IP接口（国内地址更精准）
			// 		const res = await fetch("https://ip.chinaz.com/getip.aspx");
			// 		if (!res.ok) throw new Error("请求失败");
			// 		// 注意：该接口返回的是 JSONP 格式，需要处理
			// 		const text = await res.text();
			// 		// 提取JSON部分（去掉回调函数包裹）
			// 		const jsonStr = text.replace(/^[^(]*\(/, "").replace(/\)[^)]*$/, "");
			// 		const data = JSON.parse(jsonStr);
			// 		currentIP = data.ip || "未知IP";
			// 		ipLocation = data.address || "未知地址";
			// 	} catch (error) {
			// 		console.error("获取IP失败：", error);
			// 		currentIP = "获取失败";
			// 		ipLocation = "获取失败";
			// 	}
			// 	let keyword = "商户:" + res.userInfo.userName + ",低代码后台登录, 低代码平台, IP:" + currentIP +
			// 		ipLocation + ",账号:" + res.userInfo.account;
			// 	let url =
			// 		"https://xcx11.5izg.bj.cn/tools/post.ashx?act=wx_template_notice&openid=oINr8jmIimQkTbbdht_KYJsx7HFU&notice_name=会员充值提醒&first_line=&end_line=&keyword=" +
			// 		keyword +
			// 		"&s_manager=13366682206&kh=13366682206&order_no=&openUrl=&type=超管&name=超管";
			// 	axios.get(url)
			// 		.then(response => {
			// 		})
			// 		.catch(error => {
			// 			console.error("There was an error!", error);
			// 		});
			// },
			// 在百度获取这个ip对应的城市信息
			async getUserAddressByIP(_IP) {
				// 默认地址
				let userAddress = "未获取到地址";
				// 拼接百度API请求地址
				const baidu_url =
					`https://opendata.baidu.com/api.php?query=${_IP}&co=&resource_id=6006&oe=utf8`;

				try {
					// 发送GET请求（等效于C#的Utils.HttpGet）
					const response = await axios.get(baidu_url);
					const res = response.data; // 获取响应数据

					// 解析JSON（等效于C#的JObject.Parse）
					// axios会自动解析JSON，所以这里res已经是对象，无需手动JSON.parse
					if (res.status === "0") {
						const data = res.data;
						// 判断data是否为空数组
						if (Array.isArray(data) && data.length > 0) {
							// 获取location字段
							userAddress = data[0].location || "未获取到地址";
						}
					}
				} catch (ex) {
					// 捕获异常并返回错误信息
					userAddress = ex.message || "请求失败";
				}

				return userAddress;
			},


			// 注册
			register() {
				this.$refs["register"].validate(async (valid) => {
					if (valid) {
						let res = await register(this.registerForm);
						if (res.status == "10000") {
							this.$notify({
								title: "注册成功",
								message: "账户已注册成功，快去登录使用吧",
								type: "success",
							});
							this.active = "login";
							setTimeout(() => {
								this.$refs["login"].resetFields();
							}, 0);
						} else {
							this.$notify({
								title: "注册失败",
								type: "warning",
								message: res.message,
							});
						}
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-input__inner {
		border: 0;
		border-radius: 0;
		padding: 0;
		font-size: 16px;
		border-bottom: solid 1px #dcdee0 !important;
	}

	::v-deep .el-input__icon {
		font-size: 20px;
	}

	.login {
		display: flex;
		justify-content: center;
		width: 100vw;
		height: 100vh;
		background: #f2f3f5;
		overflow: hidden;

		.login-content {
			display: flex;
			height: 500px;
			margin-top: 200px;

			.login-content-left {
				width: 550px;
				margin-right: 20px;
				border-radius: 6px;
				background: #fff;
				padding: 50px 56px 60px;

				.tab {
					font-size: 20px;
					color: $color-grey;
					cursor: pointer;
				}

				.tab-active {
					font-size: 24px;
					color: #323233;
					font-weight: 500;
				}
			}

			.login-content-right {
				display: flex;
				align-items: center;
				width: 320px;
				border-radius: 6px;
				background: #fff;
			}
		}
	}
</style>